<template>
  <div>
    <uni-popup ref="boilmsg" type="bottom">
      <uni-card title="煎药信息" :is-full="true" :note="true">
        <!-- 宁城县中心医院 -->
        <div v-if="['28770'].includes(hospitalID)" class="drug_wrap">
          <!-- 中医院并且处方类型为中药颗粒处方 prescripType 6  hospitalID 27216 加工方式为默认值 并且不可修改-->
          <div class="has-required">
            <div class="required-star">*</div>
            <ms-select-dicNew
              :code="'process_mode'"
              :title="'煎药方式：'"
              :right-text="form.processMode"
              :uniListTop="true"
              @changeDicValue="changeProcessMode"
            ></ms-select-dicNew>
          </div>
        </div>
        <!-- 其他医院 -->
        <div v-else class="drug_wrap">
          <!-- 中医院并且处方类型为中药颗粒处方 prescripType 6  hospitalID 27216 加工方式为默认值 并且不可修改-->
          <ms-select-dicNew
            v-if="prescripType == 6 && hospitalInfo.hospitalID == '27216'"
            :code="'process_method'"
            :title="'加工方式：'"
            :right-text="form.processMethod"
            @changeDicValue="changeProcessMethod"
          ></ms-select-dicNew>
          <ms-select-dicNew
            v-else
            :code="'process_method'"
            :title="'加工方式：'"
            :right-text="form.processMethod"
            @changeDicValue="changeProcessMethod"
          ></ms-select-dicNew>
          <ms-select-dicNew
            :code="'process_mode'"
            :title="'煎药方式：'"
            :right-text="form.processMode"
            :uniListTop="true"
            @changeDicValue="changeProcessMode"
          ></ms-select-dicNew>
          <ms-select-dicNew
            :code="'prescrip_solution'"
            :title="'煎药方案：'"
            :right-text="form.processSolution"
            :uniListTop="true"
            @changeDicValue="changeProcessSolution"
          ></ms-select-dicNew>
        </div>
        <template v-slot:footer>
          <div class="footer-box" @click="confirmUpdateUsage">
            <span class="btn">确定</span>
          </div>
        </template>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
  </div>
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
import { mapState } from 'vuex'
import MsSelectDicNew from '@/views/funcPuzzle/components/ms-select-dicNew/ms-select-dicNew.vue'

export default {
  components: {
    'ms-select-dicNew': MsSelectDicNew
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    boilMsg: {
      type: [Object],
      default: () => ({})
    },
    prescripType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showProMethod: false,
      showProMode: false,
      showProSolution: false

      // form:{
      //     processMethod: '1',
      //     processMode: 'A001',
      //     processSolution: '02'
      // }
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos.hospitalID
    },
    hospitalID() {
      return this.hospitalID
    },
    form: {
      get() {
        return this.boilMsg
      },
      set(value) {}
    },
    ...mapState(['hospitalInfo'])
  },
  beforeDestroy() {
    this.$bus.off('boilMsgItem')
  },
  methods: {
    getKeyValueText,
    changeProcessMethod(val) {
      this.form.processMethod = val
    },
    changeProcessMode(val) {
      this.form.processMode = val
    },
    changeProcessSolution(val) {
      this.form.processSolution = val
    },
    open() {
      this.$refs.boilmsg.open()
    },
    close() {
      this.$refs.boilmsg.close()
      this.$bus.emit('cancelAddDrug', true)
    },
    showProcessMethod() {
      this.$refs.processMethod.open()
    },
    showProcessMode() {
      this.$refs.processMode.open()
    },
    showProcessSolution() {
      this.$refs.processSolution.open()
    },
    setProcessMethod(val) {
      this.form.processMethod = val
    },
    setProcessMode(val) {
      this.form.processMode = val
    },
    setProcessSolution(val) {
      this.form.processSolution = val
    },
    confirmUpdateUsage() {
      if (['28770'].includes(this.hospitalID)) {
        if (!this.form.processMode) {
          uni.showToast({
            title: '请选择煎药方式',
            icon: 'none'
          })
          return
        }
      }
      this.$refs.boilmsg.close()
      this.$emit('boilData', this.form)
      this.$bus.emit('boilMsgItem', this.form)
      this.$bus.emit('cancelAddDrug', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.drug_wrap {
  height: 19.2rem;
  overflow-y: scroll;
  overflow-x: hidden;
  .content {
    color: #888;
    line-height: 1.75;
    font-size: 0.597333rem;
    // border-top: .021333rem solid #ececec;
    padding-left: 0.512rem;
    .uni-textarea {
      display: flex;
      flex-direction: column;
      padding-top: 0.533333rem;
      .input_title {
        width: 4.266667rem;
        font-size: 0.597333rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 0.853333rem;
        margin-bottom: 0.298667rem;
      }
    }
  }
  .input_wrap {
    display: flex;
    padding: 0 0.64rem 0 0.512rem;
    align-items: center;
    justify-content: space-between;
    height: 2.005333rem;
    .input_row {
      display: flex;
      width: 3.626667rem;
      height: 100%;
      align-items: center;
      .input_con {
        text-align: right;
      }
    }
  }
}
.footer-box {
  text-align: center;
  width: 14.634667rem;
  height: 1.877333rem;
  background: #0089ff;
  border-radius: 0.938667rem;
  line-height: 1.877333rem;
  font-size: 0.682667rem;
  font-weight: 500;
  .btn {
    color: #fff;
  }
}
.has-required {
  position: relative;

  .required-star {
    color: #e63746;
    font-size: 0.682667rem;
    position: absolute;
    left: 0.277333rem;
    top: 0.789333rem;
    z-index: 1;
  }
}
</style>
